import { Briefcase, GraduationCap, Calendar, MapPin, Heart } from "lucide-react";
import { Container, Nav, Tab, Row, Col, Card, Badge } from "react-bootstrap";

const experienceData = [
    {
        title: "AI Researcher & Engineering Fellow",
        organization: "People+AI, an initiative by Ekstep Foundation",
        employmentType: "Internship",
        startDate: "May 2025",
        endDate: null,
        location: "On-Site, Bangalore, India",
        description: "Researching for DPI 2.0 in India.",
        skills: ["Research & Development", "Agentic AI", "Model Context Protocol", "Google's Agent to Agent Protocol"],
    },
    {
        title: "Marketing and Data Insights Intern",
        organization: "IWM (iFood Web Media) Technology Private Ltd.",
        employmentType: "Internship",
        startDate: "May 2024",
        endDate: "July 2024",
        location: "Remote",
        description:
            "Worked on building end-to-end NLP pipelines, created a generative AI model to automate tagging and scoring for movie content using LangChain, and improved performance of existing models.",
        skills: ["Natural Language Processing", "LangChain", "Large Language Models", "Python"],
    },
    {
        title: "Machine Learning Researcher",
        organization: "HacktivSpace Community",
        employmentType: "Part-time",
        startDate: "Oct 2023",
        endDate: "Feb 2025",
        location: "Remote",
        description:
            "Contributed to an AI bias detection model. Focused on developing interpretable models and fairness-enhancing techniques for downstream NLP applications.",
        skills: ["Bias Detection", "Transformer Models", "Research"],
    },
    {
        title: "Educator - Chemistry",
        organization: "Ptutor at Indian Institute of Technology Kanpur (IITK)",
        employmentType: "Part-time",
        startDate: "Aug 2023",
        endDate: "Jan 2025",
        location: "Remote",
        description:
            "Taught chemistry to students preparing for JEE Main and Advanced examinations. Conducted online classes and provided support to students with their queries.",
        skills: ["Teaching", "Communication", "Chemistry"],
    },
];

const educationData = [
    {
        title: "Bachelor of Technology (Hons.) in Computer Science Engineering",
        organization: "Indian Institute of Information Technology, Sri City",
        degree: "CGPA - 7.92",
        startDate: "Nov 2022",
        endDate: "Jun 2026",
        location: "Sri City, India",
        description:
            "Majoring in Computer Science with a focus on Machine Learning, Deep Learning, and Natural Language Processing. Engaged in multiple research projects and mentorship roles.",
        skills: ["Machine Learning", "Deep Learning", "Natural Language Processing", "Research"],
    },
    {
        title: "State Board - Karnataka (PU)",
        organization: "Deeksha College for Learning (CFL), Bangalore",
        degree: "Percentage - 94.16",
        startDate: "Apr 2020",
        endDate: "Jun 2022",
        location: "Bangalore, India",
        description: null,
        skills: null,
    },
    {
        title: "ICSE Board",
        organization: "Baldwin Boys' High School, Bangalore",
        degree: "Percentage - 94.33",
        startDate: "Jun 2010",
        endDate: "Mar 2020",
        location: "Bangalore, India",
        description: null,
        skills: null,
    },
];

const volunteerData = [
    {
        title: "AI-ML & DS Lead",
        organization: "GDG IIIT Sri City",
        employmentType: "Volunteer",
        startDate: "Sep 2024",
        endDate: "Apr 2025",
        location: "IIIT Sri City",
        description:
            "Led AI/ML initiatives and hosted workshops and sessions to promote practical learning and community-driven development.",
        skills: ["AI/ML", "Community Leadership", "Mentorship", "Workshops"],
    },
    {
        title: "Machine and Deep Learning Lead",
        organization: "Matrix",
        employmentType: "Volunteer",
        startDate: "May 2024",
        endDate: "Apr 2025",
        location: "IIIT Sri City",
        description:
            "Directed deep learning initiatives, organized tech talks and built hands-on projects to foster ML learning across batches.",
        skills: ["Deep Learning", "Leadership", "Community Building", "Technical Mentorship"],
    },
    {
        title: "Design Team Lead",
        organization: "IIIT Sri City",
        employmentType: "Volunteer",
        startDate: "Mar 2024",
        endDate: "Sep 2024",
        location: "Sri City, India",
        description:
            "Led the design team for multiple campus events. Coordinated with departments and event heads to deliver compelling visuals.",
        skills: ["Design", "Team Leadership", "Creativity", "Coordination"],
    },
    {
        title: "Design Team Core",
        organization: "IIIT Sri City",
        employmentType: "Volunteer",
        startDate: "Oct 2023",
        endDate: "Mar 2024",
        location: "Sri City, India",
        description:
            "Supported campus design activities by contributing posters, event branding, and social media content.",
        skills: ["Design", "Branding", "Content Creation"],
    },
    {
        title: "Design Team Lead",
        organization: "Reverb IIITS",
        employmentType: "Volunteer",
        startDate: "Oct 2023",
        endDate: "May 2024",
        location: "IIIT Sri City",
        description:
            "Oversaw design for Reverb, the institute's flagship fest. Delivered stage designs, digital creatives, and print-ready banners.",
        skills: ["Fest Management", "Visual Design", "Leadership"],
    },
    {
        title: "Design Team Core",
        organization: "GDSC IIIT Sri City",
        employmentType: "Volunteer",
        startDate: "Aug 2023",
        endDate: "May 2024",
        location: "IIIT Sri City",
        description:
            "Created assets for GDSC events including tech talks, workshops, and hackathons. Focused on brand consistency and creative clarity.",
        skills: ["Event Design", "Creative Thinking", "Figma"],
    },
    {
        title: "Design Team Core",
        organization: "IIITians Network",
        employmentType: "Volunteer",
        startDate: "Jul 2023",
        endDate: "May 2024",
        location: "Remote",
        description:
            "Collaborated remotely with IIITians Network to produce social media content and event graphics for pan-IIIT activities.",
        skills: ["Remote Collaboration", "Graphic Design", "Communication"],
    },
];


export default function ResumeSection() {
    return (
        <Container className="py-5">
            <h2 className="text-center mb-4">My Journey</h2>
            <p className="text-center text-muted mb-4">
                A timeline of my professional experience, volunteering, and education.
            </p>

            <Tab.Container defaultActiveKey="experience">
                <Nav
                variant="pills"
                className="custom-tab-pills mb-5 justify-content-center align-items-center"
                id="resume-tabs"
                >
                <Nav.Item>
                    <Nav.Link eventKey="experience">
                    <i className="fas fa-briefcase me-2"></i> Experience
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="volunteer">
                    <i className="fas fa-heart me-2"></i> Volunteer Experience
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="education">
                    <i className="fas fa-graduation-cap me-2"></i> Education
                    </Nav.Link>
                </Nav.Item>
                </Nav>

                <Tab.Content>
                    <Tab.Pane eventKey="experience">
                        <Timeline items={experienceData} type="experience" />
                    </Tab.Pane>
                    <Tab.Pane eventKey="volunteer">
                        <Timeline items={volunteerData} type="experience" />
                    </Tab.Pane>
                    <Tab.Pane eventKey="education">
                        <Timeline items={educationData} type="education" />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </Container>
    );
}

function Timeline({ items, type }) {
    return (
        <div className="timeline position-relative">
            {items.map((item, index) => (
                <TimelineItem key={index} item={item} type={type} />
            ))}
        </div>
    );
}

function TimelineItem({ item, type }) {
    return (
        <Row className="mb-5">
            <Col md={6} className="mx-auto">
                <Card className="proj-bx">
                    <Card.Body>
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <Card.Title>{item.title}</Card.Title>
                            <Badge bg={type === "education" ? "warning" : "primary"}>
                                {type === "education" ? item.degree : item.employmentType}
                            </Badge>
                        </div>

                        <Card.Subtitle className="mb-2 text-muted">{item.organization}</Card.Subtitle>

                        <div className="mb-2 text-muted d-flex flex-wrap gap-3 small">
                            <div>
                                <Calendar size={14} className="me-1" />
                                {item.startDate} – {item.endDate || "Present"}
                            </div>
                            {item.location && (
                                <div>
                                    <MapPin size={14} className="me-1" />
                                    {item.location}
                                </div>
                            )}
                        </div>

                        <Card.Text>{item.description}</Card.Text>

                        {item.skills && (
                            <div className="mt-3">
                                {item.skills.map((skill, i) => (
                                    <Badge bg="light" text="dark" key={i} className="me-2 mb-2">
                                        {skill}
                                    </Badge>
                                ))}
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}